import React, {useEffect, useState} from 'react';
import s from './Login.module.css'
import {useAppDispatch, useAppSelector} from "../../hooks/redux";
import {LoginThunk} from "../../store/reducers/ActionCreators";
import {Link, Navigate, useLocation, useNavigate} from "react-router-dom";
import {DETAILS, OPEN_ACCOUNT} from "../../router/Constants";
import CustomInput from "../../components/ui/customInput/CustomInput";
import CustomBtnPink from "../../components/ui/customBtnPink/CustomBtnPink";
import {motion} from 'framer-motion';
import closeIcon from "../../assets/img/close.png"

const Login = () => {

    const authStatus = useAppSelector(state => state.userReducer.error)

    const navigate = useNavigate();
    const dispatch = useAppDispatch()

    const [loginData, setLoginData] = useState({
        login: "",
        password: ""
    })
    const [error, setError] = useState("")
    const [validationErrors, setValidationErrors] = useState({
      login: "",
      password: "",
    })

    const location = useLocation();
    const from = location.state?.from?.pathname || DETAILS; // fallback to DETAILS if no "from"

    // login validation function
  const validateFields = () => {
    const errors = {
      login: "",
      password: "",
    }
    if (!loginData.login) {
      errors.login = "login field is required"
    }
    if (!loginData.password) {
      errors.password = "Password field is required"
    }
    setValidationErrors(errors)
    return !errors.login && !errors.password
  }

    const handleLogin = async () => {
    setError("");
    if (!validateFields()) {
        return;
    }
    try {
        const respond = await dispatch(LoginThunk(loginData));

        if (respond?.status === 401) {
            setError("invalid_credentials")
        } else if (respond?.status >= 500) {
            setError("system_error")
        } else if (respond?.status === 200) {
          // ✅ If login is successful, redirect to the "from" page
          navigate(from, { replace: true });
        } else {
            setError(respond?.data || 'something went wrong');
        }
    } catch (error) {
      console.log(error)
      setError("system_error");
    }
  };

    // navigate to presonal account page if user logged in
    const userToken = useAppSelector(state => state.userReducer.user.userToken);
    if(userToken){
      return <Navigate to={DETAILS}/>
    }

    return (
        <div className={s.wrapper}>
            <motion.div
                initial={{opacity: 0, scale: 1}}
                animate={{opacity: 1, scale: 1}}
                transition={{duration: 0.5}}
                className={s.motion_div}
            >
                <div className={s.content}>
                    {error && (
                      <div className={s.error}>
                        <span>{error}</span>
                        <img src={closeIcon} alt="close icon" onClick={() => setError("")} />
                      </div>
                    )}
                    <div className={s.title}>
                        log in
                    </div>
                    <div className={s.inputs_block}>
                        <div className={s.login_input_block}>
                            <CustomInput id={"login"}
                                         name={"login"}
                                         type={"text"}
                                         onChange={(e) =>
                                             setLoginData({
                                                 ...loginData,
                                                 login: e.currentTarget.value
                                             })}
                                         value={loginData.login}
                                         placeholder={"Login *"}
                                         required
                            />
                            {validationErrors.login && <span className={s.error_text}>* {validationErrors.login}</span>}
                        </div>
                        <div className={s.password_input_block}>
                            <CustomInput id={"password"}
                                         name={"password"}
                                         type={"password"}
                                         onChange={(e) =>
                                             setLoginData({
                                                 ...loginData,
                                                 password: e.currentTarget.value
                                             })}
                                         value={loginData.password}
                                         placeholder={"Password *"}
                                         password
                                         required
                            />
                            {validationErrors.password && <span className={s.error_text}>* {validationErrors.password}</span>}
                        </div>
                        <span className={s.link_block}>
                        If you don't have an account,<Link className={s.link} to={OPEN_ACCOUNT}> Sign Up</Link>
                    </span>
                        <div className={s.btn_block}>
                            <CustomBtnPink title={"Log In"} onClick={() => {
                                handleLogin()
                            }}/>
                        </div>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default Login;
